import api from "./api";

const blockingService = {
  getBlockedSites: async (params?: any) => {
    try {
      const response = await api.get("/blocking/sites", { params });
      return response.data;
    } catch (error) {
      console.error("Blocked sites API error:", error);
      throw error;
    }
  },

  getBlockedCategories: async (params?: any) => {
    try {
      const response = await api.get("/blocking/categories", { params });
      return response.data;
    } catch (error) {
      console.error("Blocked categories API error:", error);
      throw error;
    }
  },

  blockSite: async (data: {
    url: string;
    reason: string;
    category?: string;
  }) => {
    try {
      const response = await api.post("/blocking/sites", data);
      return response.data;
    } catch (error) {
      console.error("Block site API error:", error);
      throw error;
    }
  },

  unblockSite: async (id: number) => {
    try {
      const response = await api.delete(`/blocking/sites/${id}`);
      return response.data;
    } catch (error) {
      console.error("Unblock site API error:", error);
      throw error;
    }
  },

  blockCategory: async (data: { name: string; description?: string }) => {
    try {
      const response = await api.post("/blocking/categories", data);
      return response.data;
    } catch (error) {
      console.error("Block category API error:", error);
      throw error;
    }
  },

  unblockCategory: async (id: number) => {
    try {
      const response = await api.delete(`/blocking/categories/${id}`);
      return response.data;
    } catch (error) {
      console.error("Unblock category API error:", error);
      throw error;
    }
  },

  getBlockingStats: async () => {
    try {
      const response = await api.get("/blocking/statistics");
      return response.data;
    } catch (error) {
      console.error("Blocking stats API error:", error);
      throw error;
    }
  },

  importBlockList: async (data: { type: string; list: any[] }) => {
    try {
      const response = await api.post("/blocking/import", data);
      return response.data;
    } catch (error) {
      console.error("Import block list API error:", error);
      throw error;
    }
  },

  getAvailableCategories: async () => {
    try {
      const response = await api.get("/blocking/available-categories");
      return response.data;
    } catch (error) {
      console.error("Available categories API error:", error);
      throw error;
    }
  },

  updateBlockingStats: async () => {
    try {
      const response = await api.post("/blocking/update-stats");
      return response.data;
    } catch (error) {
      console.error("Update stats API error:", error);
      throw error;
    }
  },
};

export default blockingService;
